import { Link } from '@framework/router/Next/Link';
import { Label } from '@creditflowresearch/uilib/Badge/Label';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

import styles from './sector.module.scss';

export const Sector = ({ row: deal }: { row: IDealCellData }) => {
  return (
    <Tooltip content={ `${ deal.dealTypeObject.name }: ${ deal.dealTypeSubObject.name } ` }>
      <Link
        to={ deal.sectorIndustryLink }
        onClick={ (event) => event.stopPropagation() }
        dataTest="dealRowSectorIndustryLink"
      >
        <Label
          backgroundColor={ deal.dealTypeObject.color }
          className={ styles.sectorLabel }
        >
          { deal.dealTypeObject.abbreviation }
        </Label>
      </Link>
    </Tooltip>
  );
};
